// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8281cbf8","511":"06abe799","513":"6665895c"}[chunkId] + ".chunk.js";
};